var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("span", [
    _c(
      "button",
      {
        staticClass: "button is-small",
        on: {
          click: function ($event) {
            _vm.isActive = !_vm.isActive
          },
        },
      },
      [
        _vm._m(0),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.$t("common.start")))]),
      ]
    ),
    _vm._v(" "),
    _vm.isActive
      ? _c(
          "div",
          { staticClass: "modal", class: { "is-active": _vm.isActive } },
          [
            _c("div", { staticClass: "modal-background" }),
            _vm._v(" "),
            _c("div", { staticClass: "modal-card" }, [
              _c("header", { staticClass: "modal-card-head" }, [
                _c("p", { staticClass: "modal-card-title" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t("common.startFor", {
                        target: _vm.$t("term.drill"),
                      })
                    )
                  ),
                ]),
                _vm._v(" "),
                _c("button", {
                  staticClass: "delete",
                  attrs: { "aria-label": "close" },
                  on: {
                    click: function ($event) {
                      _vm.isActive = !_vm.isActive
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _c(
                "section",
                { staticClass: "modal-card-body py-6" },
                [
                  _c("PostStart", {
                    attrs: { "category-slug": _vm.categorySlug },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("footer", { staticClass: "modal-card-foot" }, [
                _c(
                  "button",
                  {
                    staticClass: "button",
                    on: {
                      click: function ($event) {
                        _vm.isActive = !_vm.isActive
                      },
                    },
                  },
                  [_vm._v("\n          Cancel\n        ")]
                ),
              ]),
            ]),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "far fa-play-circle" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }